export default __webpack_public_path__ + "static/media/udemy-2.adea6f39.png";